<template lang="pug">
    section
        .head
            h4 von
                span.is-username(v-html="comment.username")
            StarRating(
                v-if="rating"
                :rating="rating"
                :increment="0.1"
                :read-only="true"
                :show-rating="false"
                :max-rating="stars"
                :star-size="14"
                :inline="true"
            )
            span.date {{ comment.created_at | date }}
        .body
            p(v-html="comment.body")
</template>
<script>

import moment from 'moment'

export default {
    name: 'Comment',
    props: {
        stars: {
            type: Number,
            default: 5
        },
        comment: {
            required: true,
            type: Object
        }
    },
    computed: {
        rating() {
            return this.comment.rating / 100 * this.stars
        }
    },
    filters: {
        date(timestamp) {
            moment.locale('de')
            // return moment.unix(timestamp).format('LLLL')
            return moment.unix(timestamp).fromNow()
        }
    }
}
</script>
<style lang="sass" scoped>
    .head
        display: flex
        h4
            flex-grow: 1
        .date
            font-size: .85rem
            margin-left: 10px
    .is-username
        margin-left: 4px
        font-weight: bold
</style>
